import dribbleIcon from "../../../../assets/img/icons/dribble.png";
import vimeoIcon from "../../../../assets/img/icons/vimeo.png";
import youtubeIcon from "../../../../assets/img/icons/youtube.png";
import behanceIcon from "../../../../svg/behance.svg";
import mediumIcon from "../../../../svg/medium.svg";
import canvaIcon from "../../../../svg/canva.svg";
import instagramIcon from "../../../../assets/img/icons/instagram.png";
import twitterIcon from "../../../../assets/img/icons/twitter.png";
import facebookIcon from "../../../../assets/img/icons/facebook.png";
import activeOrganization from "../../../../svg/active-organization.svg"


const PersonalDetails = ({data}) => {
    const getPrefrerenceUrl = (type) => {
        const record = data.aboutId?.professionalPresence.find(a => a.professionalKey === type)
        return record ? record.link : '';
    }
    const getPrefrerenceChecked = (type) => {
        const record = data.aboutId?.professionalPresence.find(a => a.professionalKey === type)
        return record ? record.subscribe : false;
    }

    const getUrlValue = (type = "") => {
      const record  = data.aboutId?.socialLinks?.find(a => a.professionalKey === type) || {};
      return record.link
    }
  
    const getIsSubscribe = (type = "") => {
      const record  = data.aboutId?.socialLinks?.find(a => a.professionalKey === type) || {};
      return record.subscribe
    }

    return(
        <>
        <div className="boxCover noStyle pt-0">
          <div className="fieldSet border-0 px-4">
            <ul>
              <li>
                <div className="fieldName mb-3">
                  <div className="fieldWrap">
                    <label className="labelForm">Title</label>
                    <div>
                      <p className="fieldForm">{data.title}</p>
                    </div>
                  </div>
                  <div className="fieldWrap">
                    <label className="labelForm">Full Name</label>
                    <div>
                      <p className="fieldForm">{data.fullName}</p>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="fieldWrap mb-3">
                  <label className="labelForm">Company Name</label>
                  <div className="fieldCover">
                    {/* <b className="icon-building" /> */}
                    <img src={activeOrganization} alt="organizationName" className="pre-icon" />
                    <p className="fieldForm">{data.organizationName}</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="fieldWrap mb-3">
                  <label className="labelForm">Email ID</label>
                  <div className="fieldCover">
                    <b className="icon-email" />
                    <p className="fieldForm">{data.email}</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="fieldWrap mb-3">
                  <label className="labelForm">Gender</label>
                  <div>
                    <p className="fieldForm">{data?.aboutId?.gender}</p>
                  </div>
                </div>
              </li>
              <li className="fullWidth pt-3">
                <div className="fieldWrap mb-1">
                  <h3 className="labelHeading mb-2">
                    Professional Summary <span>
                      {/* (word limit - 500 words) */}
                      </span>
                  </h3>
                  <div>
                    <p className="fieldForm textarea" placeholder="Type Here">
                        {data?.aboutId?.professionalSummary}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          
          <div className="fieldSet px-4">
            <h3 className="labelHeading mb-4">Mailing Address<small class="labelBadge">Private</small></h3>
            <ul>
              <li>
                <div className="fieldWrap mb-3">
                  <label className="labelForm">Apartment/House Number</label>
                  <div>
                    <p className="fieldForm">{data.aboutId?.mailingAddress?.apartment_house_no}</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="fieldWrap mb-3">
                  <label className="labelForm">City</label>
                  <div>
                    <p className="fieldForm">{data.aboutId?.mailingAddress?.city}</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="fieldWrap mb-3">
                  <label className="labelForm">State</label>
                  <div>
                    <p className="fieldForm">{data.aboutId?.mailingAddress?.state}</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="fieldWrap mb-3">
                  <label className="labelForm">Pin Code</label>
                  <div>
                    <p className="fieldForm">{data.aboutId?.mailingAddress?.pincode}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className="fieldSet px-4">
            <div className="fieldRow">
              <div className="fieldCol">
                <div className="fieldWrap">
                  <label className="labelForm">Professional Website</label>
                  {data.aboutId?.website?.length > 0 ?
                    data.aboutId?.website.map(web => {
                      return(
                          <div key={web} className="fieldCover">
                            <b className="icon-link" />
                            <p key={web} className="fieldForm mt-1">{web}</p>
                          </div>
                      )
                    })
                  :
                  <div className="fieldCover">
                            <b className="icon-link" />
                            <p  className="fieldForm mt-1">No Website</p>
                          </div>
                  }
                </div>
              </div>
              <div className="fieldCol">
                <div className="fieldWrap">
                  <label className="labelForm">Known Languages</label>
                  <div className="tagWrap">
                    {data.aboutId?.languagesKnown.map(lang => {
                        return lang && <div className="tagBox">{lang} </div>
                    })}
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="boxCover noStyle">
          <div className="fieldSet pt-0 border-0 px-4">
            <h2 className="mb-4 titleText">Your Social Presence</h2>
            <p className="text-end show_publicly">Show Publicly</p>
            <ul className="presenceList pt-1">
              <li className="presenceItem">
                <div className="presenceName">
                  <span className="presenceIcon">
                    <img src={twitterIcon} alt="#" />
                  </span>{" "}
                  Twitter
                </div>
                <div className="presenceUrl">
                  <div className="fieldWrap">
                    <div className="fieldCover">
                      <b className="icon-link" />
                      <p className="fieldForm">{getUrlValue('twitter')}</p>
                    </div>
                  </div>
                </div>
                <div className="presenceView text-center">
                  <div className="form-check form-switch d-inline-flex mb-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={getIsSubscribe('twitter')}
                      disabled
                    />
                  </div>
                </div>
              </li>
              <li className="presenceItem">
                <div className="presenceName">
                  <span className="presenceIcon">
                    <img src={instagramIcon} alt="#" />
                  </span>{" "}
                  Instagram
                </div>
                <div className="presenceUrl">
                  <div className="fieldWrap">
                    <div className="fieldCover">
                      <b className="icon-link" />
                      <p className="fieldForm">{getUrlValue('instagram')}</p>
                    </div>
                  </div>
                </div>
                <div className="presenceView text-center">
                  <div className="form-check form-switch d-inline-flex mb-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={getIsSubscribe('instagram')}
                      disabled
                    />
                  </div>
                </div>
              </li>
              <li className="presenceItem">
                <div className="presenceName">
                  <span className="presenceIcon">
                    <img src={facebookIcon} alt="#" />
                  </span>{" "}
                  Facebook
                </div>
                <div className="presenceUrl">
                  <div className="fieldWrap">
                    <div className="fieldCover">
                      <b className="icon-link" />
                      <p className="fieldForm">{getUrlValue('facebook')}</p>
                    </div>
                  </div>
                </div>
                <div className="presenceView text-center">
                  <div className="form-check form-switch d-inline-flex mb-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={getIsSubscribe('facebook')}
                      disabled
                    />
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className="fieldSet px-4">
            <h2 className="mb-4 mt-2 titleText">Your Professional Presence</h2>
            <ul className="presenceList pt-1">
              <li className="presenceItem">
                <div className="presenceName">
                  <span className="presenceIcon">
                    <img src={dribbleIcon} alt="#" />
                  </span>{" "}
                  Dribbble
                </div>
                <div className="presenceUrl">
                  <div className="fieldWrap">
                    <div className="fieldCover">
                      <b className="icon-link" />
                      <input
                        className="fieldForm"
                        type='url'
                        defaultValue={getPrefrerenceUrl('dribble')}
                        placeholder="Add URL"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="presenceView text-center">
                  <div className="form-check form-switch d-inline-flex mb-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={getPrefrerenceChecked('dribble')}
                      disabled
                    />
                  </div>
                </div>
              </li>
              <li className="presenceItem">
                <div className="presenceName">
                  <span className="presenceIcon">
                    <img src={vimeoIcon} alt="#" />
                  </span>{" "}
                  Vimeo
                </div>
                <div className="presenceUrl">
                  <div className="fieldWrap">
                    <div className="fieldCover">
                      <b className="icon-link" />
                      <input
                        className="fieldForm"
                        type="url"
                        defaultValue={getPrefrerenceUrl('vimeo')}
                        placeholder="Add URL"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="presenceView text-center">
                  <div className="form-check form-switch d-inline-flex mb-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      disabled
                      checked={getPrefrerenceChecked('vimeo')}
                    />
                  </div>
                </div>
              </li>
              <li className="presenceItem">
                <div className="presenceName">
                  <span className="presenceIcon">
                    <img src={youtubeIcon} alt="#" />
                  </span>{" "}
                  YouTube
                </div>
                <div className="presenceUrl">
                  <div className="fieldWrap">
                    <div className="fieldCover">
                      <b className="icon-link" />
                      <input
                        className="fieldForm"
                        type="url"
                        defaultValue={getPrefrerenceUrl('youtube')}
                        placeholder="Add URL"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="presenceView text-center">
                  <div className="form-check form-switch d-inline-flex mb-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={getPrefrerenceChecked('youtube')}
                      disabled
                    />
                  </div>
                </div>
              </li>
              
              {
                data?.aboutId?.professionalPresence?.find((ele) => ele?.professionalKey === "behance") ? (
              <li className="presenceItem">
                <div className="presenceName">
                  <span className="presenceIcon">
                    <img src={behanceIcon} alt="#" />
                  </span>{" "}
                  Behance
                </div>
                <div className="presenceUrl">
                  <div className="fieldWrap">
                    <div className="fieldCover">
                      <b className="icon-link" />
                      <input
                        className="fieldForm"
                        type='url'
                        defaultValue={getPrefrerenceUrl('behance')}
                        placeholder="Add URL"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="presenceView text-center">
                  <div className="form-check form-switch d-inline-flex mb-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={getPrefrerenceChecked('behance')}
                      disabled
                    />
                  </div>
                </div>
              </li>
                ) : null
              }

              {
                data?.aboutId?.professionalPresence?.find((ele) => ele.professionalKey === "medium") ? (
              <li className="presenceItem">
                <div className="presenceName">
                  <span className="presenceIcon">
                    <img src={mediumIcon} alt="#" />
                  </span>{" "}
                  Medium
                </div>
                <div className="presenceUrl">
                  <div className="fieldWrap">
                    <div className="fieldCover">
                      <b className="icon-link" />
                      <input
                        className="fieldForm"
                        type='url'
                        defaultValue={getPrefrerenceUrl('medium')}
                        placeholder="Add URL"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="presenceView text-center">
                  <div className="form-check form-switch d-inline-flex mb-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={getPrefrerenceChecked('medium')}
                      disabled
                    />
                  </div>
                </div>
              </li>
                ) : null
              }

              {
                data?.aboutId?.professionalPresence?.find((ele) => ele?.professionalKey === "canva") ? (
              <li className="presenceItem">
                <div className="presenceName">
                  <span className="presenceIcon">
                    <img src={canvaIcon} alt="#" />
                  </span>{" "}
                  Canva
                </div>
                <div className="presenceUrl">
                  <div className="fieldWrap">
                    <div className="fieldCover">
                      <b className="icon-link" />
                      <input
                        className="fieldForm"
                        type='url'
                        defaultValue={getPrefrerenceUrl('canva')}
                        placeholder="Add URL"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="presenceView text-center">
                  <div className="form-check form-switch d-inline-flex mb-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={getPrefrerenceChecked('canva')}
                      disabled
                    />
                  </div>
                </div>
              </li>
                ) : null
              }

            </ul>
            {/* <div class="fieldMore px-1">
                    <a>+ Add Another</a>
                </div> */}
          </div>
        </div>
        </>
    )    
}

export default PersonalDetails;